import { useEffect } from 'react'
import { useLocation } from 'react-router'

import { isRegistrationRoute, startRegistrationRecording } from 'common/analytics'

// Watches route changes and starts targeted session replay whenever the user
// enters a registration / account-creation flow. Renders nothing; must be
// mounted inside the router tree so useLocation() has router context.
const RegistrationReplayWatcher = () => {
  const location = useLocation()

  useEffect(() => {
    if (isRegistrationRoute(location.pathname)) {
      startRegistrationRecording()
    }
  }, [location.pathname])

  return null
}

export default RegistrationReplayWatcher
